<script>
export const group = 'Bottom'
</script>

<script setup>
import { colors } from '../../../tailwindTheme.config.js'
import PositiveWaveLoop1 from '../../../assets/animations/energetic_frequencies/loops/positive_wave_loop_1.json'
import AnimatedBackground from '../../AnimatedBackground.vue'
import ChartTrackRow from './shared/ChartTrackRow.vue'
import useChart from '../../../composables/useChart.js'
const gsapTimeline = useGsapTimeline()

const props = defineProps({
  item: Object,
})

const colorScheme = {
  current: {
    backgroundColor: '#fff',
    color: colors.q.cr.gray.lighter,
  },
  other: {
    backgroundColor: colors.q.cr.gray.primary,
    color: colors.q.cr.gray.darker,
  },
}

const contentElement = ref(null)
const listTitleElement = ref(null)
const trackElements = ref(null)
const trackListContainerElement = ref(null)

const { chart, tracks, currentPosition } = useChart(props, 3)

onMounted(() => {
  if (!tracks.value) return

  const currentIndex = Object.values(tracks.value).findIndex((track) => track.position === currentPosition.value)
  if (currentIndex === -1) return

  const allTrackElementsExceptCurrent = Array.from(trackElements.value).filter((item, index) => index !== currentIndex)

  gsapTimeline({ name: 'ChartPositionSmall', delay: 1 })
    .set(allTrackElementsExceptCurrent, { height: 0, overflow: 'hidden' })
    .from(listTitleElement.value, { opacity: 0, y: 50, duration: frames(12), ease: 'back.out(1.4)' })
    .from(trackListContainerElement.value, { scale: 0, rotationY: 25, duration: frames(8), ease: 'back.out' }, `=-${frames(4)}`)
    .to(allTrackElementsExceptCurrent, { height: 'auto', duration: frames(12), ease: 'power2.out' }, `+=${frames(30)}`)
})
</script>

<template>
  <div class="h-full w-full">
    <div v-if="chart" ref="contentElement" class="absolute bottom-0 left-0 p-safe">
      <div ref="listTitleElement" class="text-[2.5rem] tracking-tight text-white font-cervo font-bold mb-3">{{ chart.editionName }}</div>
      <div v-if="tracks" ref="trackListContainerElement" class="flex flex-col rounded-2xl bg-white overflow-hidden relative w-[680px]">
        <div>
          <div v-for="(track, position) in tracks" ref="trackElements" :key="position" class="relative z-[5]">
            <ChartTrackRow
              :track="track"
              :position="position"
              :currentPosition="currentPosition"
              :chart="chart"
              rowClass="h-24 p-3 pr-4 gap-4"
              textClass="text-[1.8rem]"
              positionClass="text-[2.5rem]"
              movementClass="text-[1.4rem] -mb-2"
              :placeholderClass="['h-7 w-48', 'h-6 w-32']"
              thumbnailSize="w240"
            />
          </div>
        </div>
        <div class="absolute z-0 bottom-0 left-0 w-full h-full overflow-hidden opacity-40">
          <AnimatedBackground :lottie="PositiveWaveLoop1" :backgroundColor="colorScheme.current.backgroundColor" :color="colorScheme.current.color" :scale="4" />
        </div>
      </div>
    </div>
  </div>
</template>
